import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

export default function (countryCode) {
  return countries.getNames('en')[countryCode];
}
